import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Asterisk } from 'lucide-react';
import { cn } from '@fortem-monorepo/js-utilities';
import { useFormField } from '../../ui/form';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
/**
 * Easily handle form errors with react-hook-form
 */
export const FormError = ({ className }) => {
    const { error, name } = useFormField();
    return (_jsx("div", { className: 'text-muted-foreground text-xs fade-in animate-in duration-500 h-3.75! overflow-hidden', children: (error?.message ?? error?.[name]?.message) ? (_jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: _jsx("div", { className: cn('text-muted-foreground text-xs fade-in animate-in duration-500 h-3.75!', 'leading-[1.1] whitespace-nowrap text-ellipsis overflow-hidden', className), children: _jsx(Asterisk, { size: 15, className: 'text-red-600' }) }, 'error') }), _jsx(TooltipContent, { children: error?.message ?? error?.[name]?.message })] })) : (_jsx("div", { className: 'invisible', children: "." })) }));
};
